export default el => {
  // Templates
  const footerNavTemplate = document.querySelector('#checkout-footer-nav')
  const lineItems = document.querySelector('#chekout-summary-items')
  const customText = document.querySelector('#checkout-custom-text')

  // elements
  const customToggle = document.querySelector('.js-toggle-summary')
  const realToggle = document.querySelector('.order-summary-toggle')

  if (footerNavTemplate) {
    const html = footerNavTemplate.innerHTML

    document.querySelector('.copyright-text').innerHTML = html
  }

  if (customText) {
    const orderSummary = document.querySelector('#order-summary')
    const html = customText.innerHTML

    orderSummary.insertAdjacentHTML('beforebegin', html)
  }

  if (lineItems) {
    const items = lineItems.innerHTML.split('<br>')
    const summaryItems = [...document.querySelectorAll('.product__description__variant')]

    summaryItems.forEach((item, index) => {
      item.innerHTML = items[index]
    })
  }

  if (customToggle) {
    customToggle.addEventListener('click', function () {
      this.classList.toggle('active-toggle')
      realToggle.click()
    })
  }
}
